import {Injectable} from '@angular/core';
import {SessionBehaviour} from './session-behaviour';
import {SessionContext} from './session-context';
import {SessionWebsocketService} from './session-websocket.service';

@Injectable()
export class WebsocketClientService {
    constructor(private sessionService: SessionWebsocketService) {}

    public async connect(config: {
        url: string;
        credentials: string;
        secret: string;
        contextFile?: string;
        behaviour: keyof Omit<typeof SessionBehaviour, 'prototype'>;
        heartbeatInterval: number;
    }): Promise<void> {
        const context = config.contextFile ? this.loadContext(config.contextFile) : SessionContext.allMessages();
        const behaviour = SessionBehaviour[config.behaviour]();

        await this.sessionService.connect({
            url: config.url,
            credentials: config.credentials,
            secret: config.secret,
            context,
            behaviour,
            heartbeatInterval: config.heartbeatInterval
        });

        this.startMessageListener(config.contextFile);
    }

    public async disconnect(): Promise<void> {
        await this.sessionService.close();
    }

    private startMessageListener(contextFile?: string): void {
        this.sessionService.recv().then(message => {
            console.log('Received message:', message);
            // Handle message
        }).catch(error => {
            console.error('Error receiving message:', error);
        });
    }

    private loadContext(file: string): SessionContext {
        // Implementation for loading context from storage
        return SessionContext.allMessages();
    }
}
